'use client';

import type {ProductSummaryProps as Props} from './typings';

import {StyledText} from './styles';

const ProductSummaryText = ({categoryName, artistName, price}: Props): JSX.Element => (
  <>
    {`${categoryName} by ${artistName}: `}
    <StyledText $isBold>{price}</StyledText>
  </>
);

export default ProductSummaryText;
